import { PDP_URL_PREFIX } from './constants';
import { DataLayerProps } from '~/types/seo';
import { UserObjectProps } from '~/types/user';
import { CartItemProps, CartProps } from '~/types/cart';
import { Parameters } from '~/types/gtag';

export function getUserData(user: UserObjectProps): DataLayerProps | undefined {
  if (!user) {
    return;
  }

  const dataLayerData: DataLayerProps = {};

  dataLayerData.userId = user.id;
  dataLayerData.userEmail = user.email;
  dataLayerData.userEmailHash = user.email_hash;

  if (user.has_plus) {
    dataLayerData.hasPlus = 'True';
  }

  if (user.has_briefcase) {
    dataLayerData.hasBriefcase = 'True';
  }

  if (user.is_staff) {
    dataLayerData.isStaff = 'True';
  }

  if (user.is_betaling) {
    dataLayerData.isBetaling = 'True';
  }

  return dataLayerData;
}

export function getCheckoutDataUA(items: CartItemProps[]) {
  return {
    event: 'checkout',
    ecommerce: {
      checkout: {
        actionField: { step: 1 },
        products: items.map((x) => {
          const plan = x.deal.plans.find((p) => p.id === x.deal_plan.id);

          return {
            name: x.deal.public_name,
            id: x.deal.id,
            price: x.price,
            url: `${PDP_URL_PREFIX}${x.deal.slug}/`,
            comparisonPrice: plan?.original_price,
            quantity: x.quantity,
            image: x.deal.image,
            category: null,
            subheader: x.deal.subheader,
            endDate: x.deal_plan.end_date,
            averageRating: x.deal.average_rating,
            topReview: x.deal.top_review,
          };
        }),
      },
    },
  };
}

export function getCheckoutDataGA4(cart: CartProps): Parameters {
  return {
    currency: 'USD',
    value: cart.subtotal,
    items: cart.cart_items.map((x) => {
      const plan = x.deal.plans.find((p) => p.id === x.deal_plan.id);

      return {
        item_name: x.deal.public_name,
        item_variant: plan?.tier || 1,
        item_id: x.deal.id,
        price: Number(x.price),
        item_brand: x.deal.listing_type,
        item_category: x.deal.taxonomy?.group || '',
        item_category2: x.deal.taxonomy?.category || '',
        item_category3: x.deal.taxonomy?.subcategory || '',
        item_category4: x.deal.taxonomy?.product_tag || '',

        // GA4 custom parameter
        deal_status: x.deal.deal_status,

        // UA Custom parameters
        name: x.deal.public_name,
        id: x.deal.id,
        url: `${PDP_URL_PREFIX}${x.deal.slug}/`,
        comparisonPrice: plan?.original_price,
        quantity: x.quantity,
        image: x.deal.image,
        subheader: x.deal.subheader,
        endDate: x.deal_plan.end_date,
        averageRating: x.deal.average_rating,
        topReview: x.deal.top_review,
      };
    }),
  };
}
